module.exports = __webpack_public_path__ + "img/file-1561751743248.00b2b21c.png";